import { Component, OnInit, Input } from '@angular/core';
import { User, ThriveSignUpFormConfigurations } from "./thrive-sign-up-form.configurations";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'kla-thrive-sign-up-form',
  templateUrl: './thrive-sign-up-form.component.html',
  styleUrls: ['./thrive-sign-up-form.component.scss'],
  standalone: true,
  imports: [ CommonModule ]
})
export class ThriveSignUpFormComponent implements OnInit {

  @Input()
  public config: ThriveSignUpFormConfigurations;

  public user: User={
      firstName: "",
      lastName: "",
      zipCode: "",
      email:""
    };

  constructor() { }

  ngOnInit() {
    if(!this.config){
      this.config = <ThriveSignUpFormConfigurations>{
        title: "Sign up receive news and events updates about the community",
        titleColor: "white",
        background: "#e6673e",
        firstNamePlaceholder:"First name",
        lastNamePlaceholder:"Last name",
        zipCodePlaceholder: "Zip Code",
        emailPlaceholder: "Email",
        button: "SIGN UP"
      }
    }
    if(!this.config.title){
      this.config.title = "Sign up receive news and events updates about the community"
    }
    if(!this.config.emailPlaceholder ){
      this.config.emailPlaceholder= "Email"
    }
    if(!this.config.firstNamePlaceholder ){
      this.config.firstNamePlaceholder= "First name"
    }
    if(!this.config.lastNamePlaceholder ){
      this.config.lastNamePlaceholder= "Last name"
    }
     if(!this.config.titleColor ){
      this.config.titleColor= "white"
    }
    if(!this.config.background ){
      this.config.background= "#e6673e"
    }
     if(!this.config.button ){
      this.config.button= "SIGN UP"
    }else{
      this.config.button = this.config.button.toUpperCase();
    }
  }
  signUp() {
    eval(this.config.eval);
  }
}
